import { readCssToken } from '@shared/lib/browser'

export interface PipPalette {
  canvas: string
  tile: string
  placeholder: string
  labelBackground: string
  label: string
  control: string
  controlIcon: string
  controlHover: string
  controlOff: string
  controlOffHover: string
}

export const readPipPalette = (): PipPalette => ({
  canvas: readCssToken('--btly-base-black'),
  tile: readCssToken('--btly-surface-inverse'),
  placeholder: readCssToken('--btly-icon-default'),
  labelBackground: readCssToken('--btly-surface-blackout'),
  label: readCssToken('--btly-text-inverse'),
  control: readCssToken('--btly-surface-blackout'),
  controlIcon: readCssToken('--btly-icon-inverse'),
  controlHover: readCssToken('--btly-surface-inverse'),
  controlOff: readCssToken('--btly-action-destructive-default'),
  controlOffHover: readCssToken('--btly-action-destructive-hover'),
})
